/// <reference path="../../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';
    
    export interface IErrorModalScope extends ng.IScope {
        title: string;
        description: string;
        modalClose: () => void;
    }
    
    /**
     * ErrorModalController class
     */
    export class ErrorModalController {
        public static templateURL: string = "decorators/modals/error-modal.html";
        public static ID: string = "#id-error-modal";
        public static $name: string = "errorModalController";
        public static $inject: string[] = ['$scope', 'close', 'title', 'description'];

        private $scope: IErrorModalScope;
        private close: (parameters: ngModal.ICloseParameters) => void;

        /**
         * Constructor
         */
        constructor($scope: IErrorModalScope, close: (parameters: ngModal.ICloseParameters) => void,
                    title: string, description: string) {
            this.$scope = $scope;
            this.$scope.title = title;
            this.$scope.description = description;            
            this.close = close;
            
            this.$scope.modalClose = (): void => {
                this.close(undefined);
            };
        }
    }
}
